module.exports = __webpack_public_path__ + "img/facebook-icon.79ad5e97.svg";